import React, { useRef, useState } from 'react';
import { Col, Modal, Row } from 'react-bootstrap';
import { DateField, Dropdown, CreatableDropdown } from '.';
import InputField from './InputField';
import SimpleReactValidator from 'simple-react-validator';
import axiosInstance from '../services/AxiosInstance';
import swal from 'sweetalert';

const TableAddForm = ({
    title,
    url,
    addform,
    setModal,
    extraKey,
    getData,
    input,
    setInput,
    setShowSuccess,
    subuser,
}) => {

    let component = {
        'short-text': InputField,
        'date': DateField,
        'dropdown': Dropdown,
        'creatable': CreatableDropdown
    }
    const simpleValidator = useRef(new SimpleReactValidator())

    const [, forceUpdate] = useState()

    const handleInput = (e, name, type, addurl) => {
        if (['dropdown'].includes(type)) setInput({ ...input, [name]: e })
        else setInput({ ...input, [e.target.name]: e.target.value })
        if (e.__isNew__) {
            axiosInstance(
                addurl, {
                method: 'POST',
                data: { name: e.name }
            }).then(res => {
                setInput({ ...input, [name]: res?.data })
            }).catch(err => {
                swal("", Object.values(err.response.data).join(', '), "error", { button: "Ok!", });
            })
        }
    }

    const handleSubmit = () => {
        let valid = simpleValidator.current.allValid()
        if (!valid) {
            simpleValidator.current.showMessages()
            forceUpdate(1)
        } else {
            // eslint-disable-next-line
            var temp = addform?.forEach(res => {
                var type = res?.type;
                if (["dropdown", "creatable"].includes(type)) input[res?.name] = input[res?.name]?.id
            })
            let postData = extraKey ? { [extraKey]: input } : input;
            var suburl = input?.id ? `${subuser}${input?.id}/` : subuser;
            var lurl = input?.id ? `${url}${input?.id}/` : url;
            var posturl = subuser ? suburl : lurl;
            var method = input?.id ? "PUT" : "POST";
            axiosInstance(
                posturl, {
                method: method,
                data: postData
            }).then(res => {
                setModal(false)
                if (res.status === 201 || res.status === 200) {
                    getData();
                    setInput({});
                    setShowSuccess({ "show": true, "msg": input?.id ? "Updated" : "Added" });
                    setTimeout(() => { setShowSuccess({ "show": false }) }, 5000);
                }
            }).catch(err => {
                setModal(false)
                setInput({});
                swal("", Object.values(err.response.data).join(', '), "error", { button: "Ok!", });
            })
        }
    }

    const handleClose = () => {
        setModal(false);
        setInput({});
    }

    return (
        <Modal className="modal fade browse-job modal-bx-info editor" size="lg" show={true} onHide={() => setModal(false)}>
            <div className="my-0" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="ProfilenameModalLongTitle">Add {title}</h5>
                        <button type="button" className="close" onClick={() => setModal(false)}>
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div className="modal-body">
                        <Row>
                            {
                                addform && addform.map(res => {
                                    const Component = component[res.type];
                                    var value = input?.[res?.name];
                                    return (
                                        <Col xs="12" md="6" xl="6" lg="6" className="mt-2">
                                            <Component
                                                label={res.label}
                                                title={res.label}
                                                value={value}
                                                textType={res.textType}
                                                name={res.name}
                                                required={res.required}
                                                onChange={handleInput}
                                                // handleFiles={handleFiles}
                                                minDate={res.minDate}
                                                maxDate={res.maxDate}
                                                type={res.type}
                                                stars={res.stars}
                                                placeholder={res.placeholder}
                                                url={res?.url}
                                                options={res?.options}
                                            />
                                            {res.required === true && <span style={{ color: "#ff0000" }}>{simpleValidator.current.message(res.label, value, 'required')}</span>}
                                            {res?.addVali && <span style={{ color: "#ff0000" }}>{simpleValidator.current.message(res.label, value, res.addVali)}</span>}
                                        </Col>
                                    )
                                })
                            }
                        </Row>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="site-button" onClick={() => handleClose()}>Cancel</button>
                        <button type="button" className="site-button" onClick={() => handleSubmit()}>Save</button>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default TableAddForm;